export const getToken = () => {
  let token = null
  try {
    token = localStorage.getItem(`${process.env.REACT_APP_HOST}:user`) ? JSON.parse(localStorage.getItem(`${process.env.REACT_APP_HOST}:user`)).token : null;
  } catch (err) {

  }
  return token
}